export default "__VITE_ASSET__BQMycQbD__"